<template>
  <NuxtPage />
</template>

<script lang="ts" setup>
import { useBuybackErrorBoundary } from '~/scopes/buyback/composables/useBuybackErrorBoundary'

useBuybackErrorBoundary()
</script>
